import { Component, NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';


@Component({
    selector: 'uw-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {

  get currentLanguageIsEnglish(): boolean {
    return this._translateService.currentLang === 'en';
  }

  constructor(
    private readonly _translateService: TranslateService,
    private readonly _customNavigationService: CustomNavigationService,
  ) { }

  ngOnInit(): void {
  }

  toggle(e: Event) {
    e.preventDefault();
    localStorage.setItem('lang', this._translateService.currentLang == 'en' ? 'fr' : 'en');
    // if ( this._translateService.currentLang == 'fr'){
    //   window.location.href = environment.englishUrl + window.location.pathname + window.location.search
    // }else {
    //   window.location.href =  environment.frenchUrl + window.location.pathname + window.location.search
    // }
    // window.location.reload();

    // This code snippet is added here to change the sub url section based on the switched language and reload the page.
    if ( this._translateService.currentLang == 'en'){
      window.location.href = localStorage.getItem('baseUrl') + this._customNavigationService.replaceSubUrlToFrenchRoute(window.location.pathname) + window.location.search
    }else {
      window.location.href = localStorage.getItem('baseUrl') + this._customNavigationService.replaceSubUrlToEnglishRoute(window.location.pathname) + window.location.search
    }
  }

}

@NgModule({
    exports: [
        LanguageSelectorComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        LanguageSelectorComponent
    ]
})
export class LanguageSelectorModule { }
